import React from 'react'

function SubjectTable() {
  return (
    <div>SubjectTable</div>
  )
}

export default SubjectTable